import { render } from "./vhpProductCard.vue?vue&type=template&id=157a7c7e&scoped=true"
import script from "./vhpProductCard.vue?vue&type=script&lang=js"
export * from "./vhpProductCard.vue?vue&type=script&lang=js"

import "./vhpProductCard.scss?vue&type=style&index=0&id=157a7c7e&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157a7c7e"]])

export default __exports__